import * as types from '../constants/actionTypes';
import initialState from './initialState';
import { CATEGORY_ID } from '../constants/category';
import Immutable, { ImmutableObject } from 'seamless-immutable';

import groupBy from 'lodash.groupby';
import { PAGING_DEFAULT } from 'redhotpie-shared-lib/constants/constants';
import { ITravel, ITravelPlan, ITravelPlanFull } from 'redhotpie-shared-lib/interfaces/ITravelPlan';
import TravelPlan from 'redhotpie-shared-lib/models/travelPlans';

export interface ITravelPlanFilter {
  ageMin: number;
  ageMax: number;
  location: any;
  googleMapPlaceID: string;
  searchRadius: number;
  seekingTypes: number;
  showMeMemberType: any;
  isHasChangeFilter: boolean;
  isDoFilter: boolean;
  page: number;
}

export interface TravelPlanState {
  desOldScroll: number;
  dataActiveNow: any[];
  isLoadingActiveNow: boolean;
  dataTravelNearYou: ITravelPlanFull[];
  isLoadingTravelNearYou: boolean;
  dataTravelEvents: any[];
  isLoadingTravelEvents: boolean;
  dataListMyTravel: ITravelPlanFull[];
  isLoadingListMyTravel: boolean;
  isLoadedListMyTravel: boolean;
  isHasMoreListMyTravel: boolean;
  pageNumListMyTravel: number;
  dataDetailTravel: any;
  isLoadingDetailTravel: boolean;
  userTravel: any[];
  isLoadingDefaultPage: boolean;
  isLoadedDefaultPage: boolean;
  searchData: ITravelPlanFull[];
  isHasMoreData: boolean;
  locationSuggest: any[];
  isLoadingSearchData: boolean;
  isShowMyTravels: boolean;
  isShowAddEditModal: boolean;
  itemTravelPlanEditing: any;
  isGetUserSearchSetting: boolean;
  filter: ITravelPlanFilter;
  defaultFilter: ITravelPlanFilter;
}

export interface ITravelPlanAction {
  type: string;
  categoryId?: string;
  data?: any;
  params?: {
    id?: string;
    isLoadMore?: boolean;
    isUnInterest?: boolean;
    [key: string]: any;
  };
  flag?: boolean;
  index?: number;
  listId?: string[];
  isLoadingMore?: boolean;
  isNearYou?: boolean;
  status?: boolean;
}

export default function travelPlanReducer(
  state: ImmutableObject<TravelPlanState> = initialState.travelPlanState,
  action: ITravelPlanAction
): ImmutableObject<TravelPlanState> {
  switch (action.type) {
    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data } = action;
      const { filter, defaultFilter } = state;
      let updateObject = {};
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        updateObject = {
          filter: {
            ...filter,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          defaultFilter: {
            ...defaultFilter,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
      const { data } = action;
      const { filter, defaultFilter } = state;
      let updateObject = {};
      updateObject = {
        filter: {
          ...filter,
          searchRadius: data.filters.searchRadius,
        },
        defaultFilter: {
          ...defaultFilter,
          searchRadius: data.filters.searchRadius,
        },
        isGetUserSearchSetting: true,
      };

      return state.merge({ ...updateObject });
    }
    case types.UPDATE_MEMBER_TYPE_STATE_TRAVEL_PLAN: {
      const { flag, index } = action;

      state = state.setIn(['filter', 'showMeMemberType', 'contentTabs', `0`, 'data', `${index}`, 'active'], flag);
      return state;
    }
    // case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
    //     if(action.from === 'travelPlan'){
    //         let {filter,defaultFilter} = Immutable.asMutable(state);
    //         let memberType = filter.showMeMemberType.contentTabs[0].data;
    //         if (action.data.filters.seekingMemberType && memberType) {
    //             let powArr = utils.decimalToBinary(action.data.filters.seekingMemberType);
    //             memberType = memberType.map((item, index) => {
    //                 let idx =powArr ? powArr.indexOf(item.id) : -1;
    //                 if(idx !== -1) return {...item, active:true};
    //                 return {...item,active:false}
    //             });
    //         }
    //         return state.merge({
    //             isGetUserSearchSetting: true,
    //             filter: {
    //                 ...filter,
    //                 ageMax: action.data.filters.maxAge,
    //                 ageMin: action.data.filters.minAge,
    //                 searchRadius: action.data.filters.searchRadius,
    //                 seekingTypes: action.data.filters.seekingMemberType,
    //                 showMeMemberType: {
    //                     contentTabs: [
    //                         {
    //                             data: memberType
    //                         }
    //                     ]
    //                 },
    //             },
    //             defaultFilter:{
    //                 ...defaultFilter,
    //                 ageMax: action.data.filters.maxAge,
    //                 ageMin: action.data.filters.minAge,
    //                 searchRadius: action.data.filters.searchRadius,
    //                 seekingTypes: action.data.filters.seekingMemberType,
    //                 showMeMemberType: {
    //                     contentTabs: [
    //                         {
    //                             data: memberType
    //                         }
    //                     ]
    //                 },
    //             }
    //         });
    //     } else {
    //         return state;
    //     }
    // }
    case types.UPDATE_STATE_TRAVEL_PLAN_SUCCESS: {
      // console.log(action)
      return state.merge({ ...action.data });
    }

    case types.GET_DETAIL_TRAVEL_PLAN_SUCCESS: {
      const { dataDetailTravel } = state;
      const updateObj = action.params && action.params.id ? { [action.params.id]: action.data } : {};
      //  console.log(action)
      return state.merge({
        dataDetailTravel: { ...dataDetailTravel, ...updateObj },
        isLoadingDetailTravel: false,
      });
    }

    case types.DELETE_MY_TRAVEL_PLAN_SUCCESS: {
      const { dataListMyTravel } = state;
      if (action.listId && action.listId.length < 0) {
        return state;
      }
      const newDate = dataListMyTravel.filter(item => {
        if (!action.listId || !action.listId.length) return true;
        // eslint-disable-next-line eqeqeq
        return item.userTravelProfileID != Number(action.listId[0]);
      });
      return state.merge({ dataListMyTravel: newDate });
    }

    case types.POST_CREATE_TRAVEL_PLAN_SUCCESS: {
      const { dataListMyTravel } = state;
      const newDataListMyTravel = [...dataListMyTravel, ...[action.data]];
      return state.merge({ dataListMyTravel: newDataListMyTravel });
    }

    case types.PATCH_UPDATE_TRAVEL_PLAN_SUCCESS: {
      const { dataListMyTravel } = state;
      if (!action.data) return state;
      const indexUpdate = dataListMyTravel.findIndex(item => item.userTravelProfileID === action.data.userTravelProfileID);
      if (indexUpdate === -1) {
        return state;
      }
      const cloneArr = [...dataListMyTravel];
      cloneArr[indexUpdate] = action.data;
      return state.merge({ dataListMyTravel: cloneArr });
    }
    case types.UPDATE_TRAVEL_PLAN_NEAR_YOU: {
      return state.merge({ dataTravelNearYou: action.data });
    }

    case types.GET_MY_TRAVEL_PLAN_SUCCESS: {
      const { dataListMyTravel } = state;
      const updateParams = {
        isLoadingListMyTravel: false,
        isLoadedListMyTravel: true,
        dataListMyTravel: action.params && action.params.isLoadMore ? [...dataListMyTravel, ...action.data] : action.data,
        isHasMoreListMyTravel: !(action.data instanceof Array && action.data.length < 24),
      };
      return state.merge({ ...updateParams });
    }
    case types.GET_MY_TRAVEL_PLAN_FAILED: {
      return state.set('isLoadedListMyTravel', true);
    }
    case types.GET_USER_TRAVEL_SUCCESS: {
      const { data } = action;
      const locationSuggest: any[] = [];
      let updateParams = {};
      if (data) {
        Object.entries(groupBy(data, (item: any) => item.country)).forEach(([key, val]) => {
          let count = 0;
          const typedVal = val as any[];
          const location = {
            text: key,
            data: typedVal,
            googleMapPlaceID: typedVal && typedVal.length === 1 && typedVal[0] ? typedVal[0].googleMapPlaceID : null,
            locationType: 'Country',
            count: 0,
          };
          if (typedVal && typedVal.length > 0) {
            typedVal.forEach((item: any) => {
              count += item.count;
            });
          }
          location.count = count;
          locationSuggest.push(location);
        });
        updateParams = {
          userTravel: [...data],
          locationSuggest,
          isLoadingDefaultPage: false,
          isLoadedDefaultPage: true,
        };
      }

      return state.merge({ ...updateParams });
    }
    case types.SEARCH_TRAVEL_SUCCESS: {
      const { searchData, filter } = state;
      let tempData: any[] = [];
      const { data, params, isLoadingMore } = action;
      if (isLoadingMore) {
        tempData = [...searchData, ...data];
      } else {
        tempData = data;
      }
      const updateParams: any = {
        searchData: tempData,
        filter: {
          ...filter,
          ...params,
          page: 2,
        },
        isLoadingSearchData: false,
      };
      updateParams.isHasMoreData = true;
      if (isLoadingMore) {
        updateParams.filter.page = filter.page + 1;
      }
      updateParams.isHasMoreData = data.length >= PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH;

      return state.merge({ ...updateParams });
    }
    case types.GET_TRAVEL_PLAN_EVENTS_SUCCESS: {
      const updateParams = {
        isLoadingTravelEvents: false,
        dataTravelEvents: action.data || [],
      };

      return state.merge({ ...updateParams });
    }
    case types.TOGGLE_MY_TRAVEL_PLAN_MODAL: {
      return state.set('isShowMyTravels', !!action.status);
    }

    case types.SHOW_ADD_EDIT_TRAVEL_PLAN_MODAL: {
      if (action.data) {
        state = state.set('itemTravelPlanEditing', action.data);
      }
      return state.set('isShowAddEditModal', true);
    }

    case types.HIDE_ADD_EDIT_TRAVEL_PLAN_MODAL: {
      return state.set('isShowAddEditModal', false).set('itemTravelPlanEditing', {});
    }

    case types.CREATE_EVENT_INTEREST_TRAVEL:
    case types.DELETE_INTEREST_TRAVEL:
    case types.POST_CREATE_EVENT_INTEREST_SUCCESS:
    case types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS:
      const { dataTravelEvents } = state;
      let interestCount = 1;
      if (types.DELETE_INTEREST_TRAVEL === action.type || types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS === action.type) {
        interestCount = -1;
      }

      const index = dataTravelEvents.findIndex(itm => itm.searchItem && action.params && itm.searchItem.eventId === action.params.id);
      if (index !== -1 && action.params) {
        state = state.setIn(['dataTravelEvents', index, 'searchItem'], {
          ...dataTravelEvents[index].searchItem,
          hasExpressInterest: !action.params.isUnInterest,

          interestCount: dataTravelEvents[index].searchItem.interestCount + interestCount,
        });
      }

      return state;

    default:
      return state;
  }
}
